import { render } from "./SearchInput.vue?vue&type=template&id=29c42e18&scoped=true"
import script from "./SearchInput.vue?vue&type=script&lang=js"
export * from "./SearchInput.vue?vue&type=script&lang=js"

import "./SearchInput.vue?vue&type=style&index=0&id=29c42e18&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c42e18"]])

export default __exports__